// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Profile__General__Page[data-v-05d99b0a] {\n  padding: 20px 40px;\n}\n.Profile__General__Page .Profile__General__Page__Header[data-v-05d99b0a] {\n    border-bottom: 1px solid silver;\n    padding: 0px 10px 10px 10px;\n}\n.Profile__General__Page .Profile__General__Page__Header h1[data-v-05d99b0a] {\n      font-size: 30px;\n}\n.Profile__General__Page .Profile__General__Page__Form[data-v-05d99b0a] {\n    margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
